import AppLayout from "@/layouts/AppLayout.vue";
import InvestmentListView from "@/views/bank/investment/InvestmentListView.vue";
import WithdrawalListView from "@/views/bank/withdrawal/WithdrawalListView.vue";

export default [
  {
    path: '/bank/investments',
    name: 'investments',
    component: InvestmentListView,
    meta: {
      parent: 'bank',
      related: 'investments',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['ADMIN_INVESTMENT_MANDATE']
    }
  },
  {
    path: '/bank/withdrawals',
    name: 'withdrawals',
    component: WithdrawalListView,
    meta: {
      parent: 'bank',
      related: 'withdrawals',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['ADMIN_WITHDRAW_MANDATE']
    }
  }
];
